// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DC2X","controls":"styles_controls__2iXQB","charLimit":"styles_charLimit__3-HEm","input":"styles_input__3LHYI","send":"styles_send__19dkr"};